import React, { useMemo, useRef, useState } from "react";
import * as THREE from "three";
import { Html } from "@react-three/drei";

function ModernWall({ obj, shouldRender }) {
  const { size, position, rotation = 0 } = obj;
  let [length, height, thickness] = size;
  height = !shouldRender ? 0.01 : height;

  const rotY = rotation;

  const meshRef = useRef();
  const [mode, setMode] = useState("opaque");
  const [showCard, setShowCard] = useState(false);

  // Brick texture
  const texture = useMemo(() => {
    const canvas = document.createElement("canvas");
    canvas.width = 512;
    canvas.height = 512;
    const ctx = canvas.getContext("2d");

    const mortar = "#d9d9d9";
    const brickW = 80;
    const brickH = 40;
    const gap = 4;

    ctx.fillStyle = mortar;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    for (let y = 0; y < canvas.height; y += brickH + gap) {
      const offset = (Math.floor(y / (brickH + gap)) % 2) * (brickW / 2);
      for (let x = -offset; x < canvas.width; x += brickW + gap) {
        const variation = Math.floor(Math.random() * 20) - 10;
        const r = 183 + variation;
        const g = 90 + variation / 2;
        const b = 66 + variation / 3;

        ctx.fillStyle = `rgba(${r},${g},${b}, ${mode === "opaque" ? 0.81 : 0.5})`;
        ctx.fillRect(x, y, brickW, brickH);
      }
    }

    const tex = new THREE.CanvasTexture(canvas);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    tex.repeat.set(length / 2, height / 2);
    return tex;
  }, [size]);

  // Right-click handler to toggle card
  const handleContextMenu = (e) => {
    e.stopPropagation(); // Only stop right-click
    setShowCard((prev) => !prev);
  };

  return (
    <group rotation={[0, rotY, 0]} castShadow>
      <mesh ref={meshRef} onContextMenu={handleContextMenu} castShadow receiveShadow>
        <boxGeometry args={[length, height * 2, thickness]} />
        <meshPhysicalMaterial
          map={texture}
          bumpMap={texture}
          bumpScale={0.3}
          color={obj.color || "#ffffff"}
          roughness={0.4}
          transmission={mode === "transparent" ? 0.7 : 0}
          thickness={0.4}
          metalness={0.1}
          opacity={mode === "transparent" ? 0.35 : 1}
          transparent={mode === "transparent"}
          clipShadows
        />

        {showCard && (
          <Html distanceFactor={10} position={[0, height / 2 + 0.1, 0]} style={{ pointerEvents: "auto" }} castShadow>
            <div
              style={{
                width: "800px",
                background: "#f9f9f9",
                borderRadius: "12px",
                boxShadow: "0 12px 32px rgba(0,0,0,0.5)",
                padding: "30px",
                fontFamily: "sans-serif",
                color: "#333",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                userSelect: "none",
                fontSize: "0.85rem",
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: "4px", fontSize: "4rem" }}>Wall Mode</div>

              {["opaque", "transparent"].map((opt) => (
                <div
                  key={opt}
                  onClick={() => {
                    setMode(opt);
                    setShowCard(false);
                  }}
                  style={{
                    padding: "5px 8px",
                    borderRadius: "28px",
                    cursor: "pointer",
                    background: mode === opt ? "#007aff" : "transparent",
                    color: mode === opt ? "#fff" : "#333",
                    transition: "all 0.2s",
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: "5.5rem",
                  }}
                  onMouseEnter={(e) => {
                    if (mode !== opt) e.currentTarget.style.background = "#e6e6e6";
                  }}
                  onMouseLeave={(e) => {
                    if (mode !== opt) e.currentTarget.style.background = "transparent";
                  }}
                >
                  {opt.charAt(0).toUpperCase() + opt.slice(1)}
                </div>
              ))}
            </div>
          </Html>
        )}
      </mesh>
    </group>
  );
}

export default ModernWall;
